import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ModalFooter } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import AttachmentList from 'components/emailTemplates/EmailTemplatesForm/AttachmentList/AttachmentList';
import emailTemplatesFormValidationSchema from './emailTemplatesFormValidationSchema';
import style from './emailTemplatesForm.style';

const EmailTemplatesForm = ({
  templates = [],
  isLoading,
  onSubmit,
  onClose,
}) => {
  const resolver = yupResolver(emailTemplatesFormValidationSchema);

  const methods = useForm({
    defaultValues: {
      template: { value: '', text: '' },
      language: '',
      body: '',
      subject: '',
      attachments: [],
    },
    resolver,
  });

  const {
    control,
    formState: { isSubmitting },
  } = methods;

  const language = methods.watch('language');
  const template = methods.watch('template');
  const attachments = methods.watch('attachments');
  useEffect(() => {
    if (language) {
      const selectedTemplate = templates.find(
        (templ) => templ.id === template?.value
      );
      methods.setValue('body', selectedTemplate?.body?.[language] || '');
      methods.setValue(
        'attachments',
        selectedTemplate?.attachments?.[language] || []
      );
      methods.setValue('subject', selectedTemplate?.subject?.[language] || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language, template]);

  const templateOptions = templates.map((templ) => ({
    text: templ.name,
    value: templ.id,
  }));

  const languageOptions = [
    { text: 'English', value: 'en' },
    { text: 'Greek', value: 'gr' },
  ];

  const handleSubmit = (values) => {
    onSubmit({ ...values, template: values.template.value });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Box sx={style.row}>
          <FieldV2
            name="template"
            isRequired
            disabled={isLoading}
            control={control}
            label="Template"
            type="autocomplete"
            options={templateOptions}
          />
          <FieldV2
            name="language"
            isRequired
            disabled={isLoading}
            control={control}
            label="Language"
            type="dropdown"
            options={languageOptions}
          />
        </Box>
        <Box sx={style.row}>
          <FieldV2
            label="Body"
            disabled
            type="richText"
            name="body"
            modules={{ toolbar: false }}
            control={control}
          />
        </Box>
        <AttachmentList attachments={attachments} />
        <ModalFooter>
          <ButtonV2
            type="button"
            disabled={isSubmitting || isLoading}
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </ButtonV2>
          <ButtonV2 type="submit" disabled={isSubmitting || isLoading}>
            Add
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default EmailTemplatesForm;
